export default __webpack_public_path__ + "static/media/proj_bg.93444758.jpg";